import { track } from '../analytics/datalayer'
import { getGclid } from '../analytics/gclid'
import { appendFormToken } from './formToken'

/**
 * Micro-conversión de lead cotización en /sitios-web/inversion/ (Ja-W27-A1).
 * Rellena ts + gclid, envía por AJAX a lead-cotizacion.php, empuja el evento
 * `lead_cotizacion_enviado` (GTM → Google Ads) y muestra el éxito inline.
 */
export function initLeadCotizacion(): void {
  const form = document.getElementById('lead-cotizacion-form') as HTMLFormElement | null
  if (!form) return

  const ts = form.querySelector<HTMLInputElement>('input[name="ts"]')
  if (ts) ts.value = String(Date.now())

  const gclidInput = form.querySelector<HTMLInputElement>('input[name="gclid"]')
  if (gclidInput) gclidInput.value = getGclid() ?? ''

  const success = document.getElementById('lead-cotizacion-success')
  const btn = form.querySelector<HTMLButtonElement>('button[type="submit"]')

  form.addEventListener('submit', async (ev) => {
    ev.preventDefault()
    const status = ensureStatus(form)
    status.textContent = ''
    if (btn) btn.disabled = true
    const data = new FormData(form)
    appendFormToken(data)

    try {
      const res = await fetch(form.action, { method: 'POST', body: data })
      const json = (await res.json()) as { ok: boolean; error?: string }
      if (!json.ok) throw new Error(json.error ?? 'error')

      // Evento de conversión ANTES de cualquier cambio de UI (patrón validado del WP).
      track({
        event: 'lead_cotizacion_enviado',
        source: 'form_lead_cotizacion',
        origen: String(data.get('origen') ?? 'inversion'),
        project: String(data.get('project') ?? ''),
        email: String(data.get('email') ?? ''),
        gclid: getGclid(),
      })

      if (success) {
        form.hidden = true
        success.hidden = false
        success.scrollIntoView({ behavior: 'smooth', block: 'center' })
      } else {
        status.textContent = 'Listo. La guía va en camino a tu correo.'
        status.style.color = '#2a3d00'
        form.reset()
      }
    } catch {
      status.textContent = 'No pudimos enviarlo. Reintenta o escríbenos a hola@jalapenos.cl o por WhatsApp.'
      status.style.color = '#7a1f1f'
      if (btn) btn.disabled = false
    }
  })
}

function ensureStatus(form: HTMLFormElement): HTMLParagraphElement {
  let el = form.querySelector<HTMLParagraphElement>('.form-status')
  if (!el) {
    el = document.createElement('p')
    el.className = 'form-status'
    el.setAttribute('role', 'status')
    form.appendChild(el)
  }
  return el
}
